import readCsrfToken from "shared/utils/readCsrfToken";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { actionTypes } from "ec/redux/epics";

const headers = {
  "Content-Type": "application/json",
  "X-CSRF-Token": readCsrfToken(),
};
const parseJSON = (response) => {
  return response.text().then(function (text) {
    return text ? JSON.parse(text) : {};
  });
};
const parseOptionalJSON = (response) => parseJSON(response).catch(() => ({}));

export const useChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const cb = useCallback((input) => {
    setLoading(true);
    return fetch("/cognito_password", {
      method: "PATCH",
      headers,
      body: JSON.stringify({ user: input }),
    })
      .then((response) =>
        parseOptionalJSON(response).then((data) => {
          setLoading(false);
          if (response.ok) {
            return data;
          }
          if (data.errors) {
            return data;
          }

          return { errors: { base: "We couldn't change your password. Please try again." } };
        }),
      )
      .catch(() => {
        setLoading(false);
        return { errors: { base: "We couldn't change your password. Please try again." } };
      });
  }, []);
  return [cb, loading];
};

export const useChangeUser = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const cb = useCallback(
    (input) => {
      setLoading(true);
      return fetch("/api/users/me", {
        method: "PATCH",
        headers,
        body: JSON.stringify({ user: input }),
      })
        .then((response) =>
          parseOptionalJSON(response).then((data) => {
            setLoading(false);
            if (response.ok) {
              if (!data.errors) {
                dispatch({
                  type: actionTypes.FETCH_USER_PROFILE_SUCCESS,
                  payload: data,
                });
              }
              return data;
            }
            if (data.errors) {
              return data;
            }

            return {
              errors: { base: "We couldn't save your account information. Please try again." },
            };
          }),
        )
        .catch(() => {
          setLoading(false);
          return {
            errors: { base: "We couldn't save your account information. Please try again." },
          };
        });
    },
    [dispatch],
  );
  return [cb, loading, dispatch];
};
